// @index('./*.ts', f => `export * from '${f.path}';`)
export * from './initials.module';
export * from './initials.pipe';
// @endindex